export default "__VITE_ASSET__287658a8__"